import { render, staticRenderFns } from "./Adminer.vue?vue&type=template&id=7f397fea&scoped=true"
import script from "./Adminer.vue?vue&type=script&lang=js"
export * from "./Adminer.vue?vue&type=script&lang=js"
import style0 from "./Adminer.vue?vue&type=style&index=0&id=7f397fea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f397fea",
  null
  
)

export default component.exports